var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"movable",rawName:"v-movable"}],on:{"move:start":_vm.moveLayerStart,"move":_vm.moveLayer,"move:end":_vm.moveLayerEnd}},[_vm._v("\n\t"+_vm._s(_vm.valid)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }